export class EnterpriseStorage {
  id: number;
  partnerId: number;
  enterpriseId: number;
  storageTypeId: number;
  usedStorage: string;
  storageUnitType: string;
  limitStorage: string;
  limitStorageBytes: string;
  createAt: string;
  active: boolean;
  deleted: boolean;
}
